import { createPremiumIcon, fragment, icon, node } from "~/util/dom";

export default class ParamsItemSelect {
	_input: HTMLInputElement;

	_label: HTMLDivElement;

	_title: HTMLSpanElement;

	_popup: HTMLUListElement;

	_openState: boolean;

	_items: Array<any>;

	_iconClosed: SVGSVGElement | HTMLSpanElement;

	_iconOpen: SVGSVGElement | HTMLSpanElement;

	_selectedIndex: number;

	_type: any;

	_state: any;

	#labelIcon: HTMLSpanElement;

	constructor(type: any) {
		this._type = type;
		this._openState = false;
		this._items = [];

		this._input = node("input", { type: "hidden" });
		this._label = node("div", { className: "params-select-label" });
		this.#labelIcon = node("span", { className: "params-select-label__iconHolder" });
		this._iconClosed = icon("forward");
		this._iconOpen = icon("dropdown");
		this._label.append(this._iconClosed);
		this._title = node("span");
		this._popup = node("ul", { className: "params-select-popup" });

		const selectIndex = type.items.findIndex(item => item.selected);

		this.selectItem(selectIndex > -1 ? selectIndex : 0);
		document.body.addEventListener("click", this, false);

		// kvuli zmene usera - premium/free
		Mapy.CML.addListener((active: boolean) => {
			if (active) {
				this.selectItem(this._selectedIndex);
			}
		}, "route.active");
	}

	destroy() {
		document.body.removeEventListener("click", this, false);
		this._close();
	}

	get input() {
		return this._input;
	}

	get label() {
		return this._label;
	}

	get title() {
		return this._title;
	}

	set state(val) {
		this._state = val;
	}

	get state() {
		return this._state;
	}

	handleEvent(event: Event) {
		const target = event.target as Node;

		// klik do menu
		if (this._popup.contains(target)) {
			const index = this._items.findIndex(item => item.container.contains(target));
			const insData = this._items[index];

			if (insData.disabled || insData.container.classList.contains("selected")) {
				return;
			}

			this.selectItem(index);
			this._input.dispatchEvent(new CustomEvent("params-select-change"));
		}

		if (this._label.contains(target)) {
			if (this._openState) {
				this._close();
			} else {
				this._open();
			}
		} else {
			this._close();
		}
	}

	selectItem(index) {
		const selItem = this._type.items[index];

		this._selectedIndex = index;
		this._title.innerHTML = selItem.label;
		this.state = selItem.value;

		if (selItem.premium) {
			const userIsPremium = Mapy.CML.state.route.userIsPremium;

			this.#labelIcon.innerHTML = "";
			this.label.append(this.#labelIcon);

			if (!userIsPremium) {
				this.#labelIcon.append(createPremiumIcon());
			}
		} else {
			this.#labelIcon.remove();
		}
	}

	_close() {
		this._iconOpen.remove();
		this._label.insertBefore(this._iconClosed, this._label.firstChild);

		this._popup.innerHTML = "";
		this._items = [];

		this._openState = false;
	}

	_open() {
		this._iconClosed.remove();
		this._label.insertBefore(this._iconOpen, this._label.firstChild);

		const userIsPremium = Mapy.CML.state.route.userIsPremium;
		const frag = fragment();

		this._type.items.forEach((item, index) => {
			const itemInstance = this._type.itemFactory(item, userIsPremium);

			itemInstance.selected = index === this._selectedIndex;
			this._items.push(itemInstance);
			frag.appendChild(itemInstance.container);
		});

		this._popup.appendChild(frag);
		this._label.appendChild(this._popup);

		this._openState = true;
	}
}
